import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import { PurchaseOrderGetGridDto } from 'svila-common';
import AutocompleteComponent from '~/src/components/common/forms/Autcomplete/AutocompleteComponent';
import PrimaryButton from '~/src/components/common/forms/Button/PrimaryButton';
import { API_URL } from '../../../../utils/constants';

const schema = yup.object().shape({
  purchaseOrderId: yup.string().required(),
});

export default function PurchaseOrderDropDown(): JSX.Element {
  const history = useHistory();
  const formik = useFormik({
    initialValues: {
      purchaseOrderId: '',
    },
    validationSchema: schema,
    onSubmit: (values, { setSubmitting }) => {
      // return update(values, setSubmitting);
      history.push(`/inventory/purchase-order/${values.purchaseOrderId}`);
    },
  });

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <AutocompleteComponent
          url={`${API_URL}/purchase-orders/search`}
          name="purchaseOrderId"
          label="Purchase Order"
          initialValue={formik.values.purchaseOrderId}
          onChange={formik.setFieldValue}
          getOptionLabel={(option: PurchaseOrderGetGridDto): string =>
            `${option.orderNumber} - ${option.supplierName}  `
          }
          queryFields={['name']}
          errorMessage={formik.touched.purchaseOrderId ? formik.errors.purchaseOrderId : null}
          cols={8}
        />
        <div style={{ paddingLeft: '15px', marginTop: 25 }}>
          <PrimaryButton title="View" type="submit" />
        </div>
      </form>
    </div>
  );
}
